import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'menu-mobile',
  templateUrl: './menu-mobile.component.html',
  styleUrls: ['./menu-mobile.component.scss']
})
export class MenuMobileComponent implements OnInit {

  @Input("template") template:any = 'home';
  public categorias:any           = [];
  public openMenu  = false;

  constructor(
    private router: Router,
    private app: AppService,
    private data: DataService
  ){}

  /**
   * 
   * Toroute
   * 
   */
  toRoute(link,apelido=null){

    if(apelido == null){
      this.router.navigateByUrl(link);
      return false;
    }else{

      this.router.navigateByUrl(link+"/"+apelido);
      this.openMenu = false;
      return false;

    } 

  }
  /**
   * 
   * Open Whats
   * 
   */
  openWhats(){

    let prefixo = this.app.isMobile() ? "api" : "web";
    let numero  = "5551996852868";
    let text    = "Estava no site e gostaria de mais informações.";

    window.open("https://"+prefixo+".whatsapp.com/send?phone="+numero+"&text="+text,"__blank");  
    return false;

  }
  /**
   * 
   * Open categorias
   * 
   */
  openCategories(){

    this.openMenu = true;

  }
  /**
   * 
   * Close
   * 
   */
  close(){

    this.openMenu = false;

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{

    this.categorias = this.data.getCategoriasMenu();  

  }

}
